export const branchFilledDomains = [
  "ttec",
  "ttec-test",
  "simfer",
  "simfer-test",
  "haier",
  "haier-test",
  "kumtel",
  "kumtel-test",
  "brita",
  "brita-test",
  "akbati",
  "akbati-test",
  "akasya",
  "akasya-test",
  "omron",
  "omron-test",
  "csb",
  "csb-test",
  "hikvision",
  "hikvision-test",
  "babbowling",
  "babbowling-test",
  "smart",
  "smart-test",
  "vertiv",
  "vertiv-test",
  "xiaomi",
  "xiaomi-test",
  "astrazeneca",
  "astrazeneca-test",
];

export const customWelcomeDomains = [
  "proje",
  "proje-test",
  "simfer",
  "simfer-test",
  "tefal",
  "tefal-test",
  "ttec",
  "ttec-test",
  "akasya",
  "akasya-test",
  "akbati",
  "akbati-test",
  "kumtel",
  "kumtel-test",
  "brita",
  "brita-test",
  "haier",
  "haier-test",
];

export const vartaDomains = ["varta", "varta-test"];

export const xiaomiDomains = ["xiaomi", "xiaomi-test"];

export const inciAkuDomains = ["inciaku", "inciaku-test"];

export const astrazenecaDomains = ["astrazeneca", "astrazeneca-test"];

export const platformDomains = ["platform", "platform-test", "app", "app-test"];
